// src/auth/msalConfig.js - FIXED VERSION
import { PublicClientApplication, LogLevel, EventType } from "@azure/msal-browser";

// Check if running in legacy browsers
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
const isEdge = window.navigator.userAgent.indexOf("Edge/") > -1;
const isFirefox = window.navigator.userAgent.indexOf("Firefox/") > -1;

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: "16654fb0-e899-48f4-b82b-dccb140017c3",
    redirectUri: 'https://em-mobile-ems.azurewebsites.net/response-oidc' 
    //window.location.origin + "/response-oidc",
  },
  cache: {
    cacheLocation: "localStorage", // Use sessionStorage to avoid persistence issues during dev
    storeAuthStateInCookie: isIE || isEdge || isFirefox
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Verbose // Change to Verbose for debugging
    }
  }
};

// Create the instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL - SIMPLIFIED VERSION
let isInitialized = false;

const initializeMsal = async () => {
  if (isInitialized) return;
  
  try {
    // Initialize the instance
    await msalInstance.initialize();
    
    // Handle any pending redirects first
    const tokenResponse = await msalInstance.handleRedirectPromise();
    
    if (tokenResponse) {
      // console.log("Token response from redirect:", tokenResponse);
      msalInstance.setActiveAccount(tokenResponse.account);
    } else {
      // No redirect response, check for existing accounts
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
        // console.log("Set active account:", accounts[0]);
      }
    }

    // Add event callback for login success
    msalInstance.addEventCallback((event) => {
      // console.log("MSAL Event:", event.eventType, event);
      
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
        // console.log("Login success, active account set:", account);
      }
      
      if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload.account) {
        msalInstance.setActiveAccount(event.payload.account);
      }
      
    });

    isInitialized = true;
    // console.log('MSAL initialized successfully');
    
  } catch (error) {
    console.error('MSAL initialization failed:', error);
  }
};

// Initialize immediately
initializeMsal();

// Scopes for token requests
export const loginRequest = {
  scopes: ["openid", "profile", "api://16654fb0-e899-48f4-b82b-dccb140017c3/em.api.access"],
  // Add prompt parameter to force account selection if needed
  // prompt: "select_account"
};

export const tokenRequest = {
  scopes: ["api://16654fb0-e899-48f4-b82b-dccb140017c3/em.api.access"],
  // forceRefresh: false // Set to true if you want to force refresh
};

export const apiConfig = {
  apiData: ["api://16654fb0-e899-48f4-b82b-dccb140017c3/em.api.access"]
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};